import { createSlice } from "@reduxjs/toolkit";

export interface ITranscriptionReducerState {
  showCaptions: boolean;
}

export const transcriptionReducerInitialState: ITranscriptionReducerState = {
  showCaptions: false,
};

export const transcriptionSlice = createSlice({
  name: "transcription",
  initialState: transcriptionReducerInitialState,
  reducers: {
    toggleShowCaptions: (state) => {
      state.showCaptions = !state.showCaptions;
    },
    turnOffCaptions: (state) => {
      state.showCaptions = false;
    },
  },
});

export const { toggleShowCaptions, turnOffCaptions } =
  transcriptionSlice.actions;

export default transcriptionSlice.reducer;
